import React from 'react';
import { Navigate } from 'react-router-dom';
import { useCompetition } from './CompetitionContext';

const CompetitionGuard = ({ children }) => {
  const { hasCompetition, loading } = useCompetition();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (!hasCompetition) {
    return <Navigate to="/select-competition" replace />;
  }

  return children;
};

export default CompetitionGuard;